import React, { ComponentProps } from 'react';

import HostedField from '../HostedField';
import InputSocket from '../InputSocket';

import { CreditCardPCIFields } from '../../types';

type CardNumberProps = {
  /**
   * HTML element identifier
   */
  htmlElementId?: string;
} & ComponentProps<typeof HostedField>;

const CardNumber = ({
  htmlElementId = CreditCardPCIFields.Number,
  label,
  required,
  hasError,
}: CardNumberProps) => (
  <HostedField label={label} hasError={hasError} required={required}>
    <InputSocket hasError={hasError} id={htmlElementId} />
  </HostedField>
);

export default CardNumber;
